/**
 * SMS API Client
 * Epic 67: SMS Gateway & Kétirányú Protokoll
 */

import { api } from './client';

// ============================================
// TYPES
// ============================================

export interface SmsLog {
  id: string;
  tenantId: string;
  direction: 'OUTBOUND' | 'INBOUND';
  phoneNumber: string;
  message: string;
  status: 'PENDING' | 'SENT' | 'DELIVERED' | 'FAILED' | 'REJECTED';
  providerMessageId?: string;
  createdBy?: string;
  createdAt: string;
}

export interface SmsLogQueryResult {
  logs: SmsLog[];
  total: number;
  offset: number;
  limit: number;
}

export interface SmsTemplate {
  id: string;
  tenantId: string;
  name: string;
  type: string;
  body: string;
  variables: string[];
  active: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface SmsTemplateQueryResult {
  templates: SmsTemplate[];
  total: number;
  offset: number;
  limit: number;
}

export interface SmsSendOutcome {
  success: boolean;
  logId: string;
  providerMessageId?: string;
  error?: string;
  /** Strukturált gate-döntés (#712-minta) — a FE erre detektál, nem error-substringre. */
  gateDecision?: 'SEND' | 'DRY_RUN' | 'BLOCK';
}

// ============================================
// API CALLS
// ============================================

export async function sendSms(data: { phoneNumber: string; message: string }) {
  return api.post<{ data: SmsSendOutcome }>('/sms/send', data);
}

export async function getSmsHistory(params?: {
  direction?: string;
  status?: string;
  offset?: number;
  limit?: number;
}) {
  const query = new URLSearchParams();
  if (params?.direction !== undefined) query.set('direction', params.direction);
  if (params?.status !== undefined) query.set('status', params.status);
  if (params?.offset !== undefined) query.set('offset', String(params.offset));
  if (params?.limit !== undefined) query.set('limit', String(params.limit));
  const qs = query.toString();
  return api.get<{ data: SmsLogQueryResult }>(`/sms/history${qs ? `?${qs}` : ''}`);
}

export async function listSmsTemplates() {
  return api.get<{ data: SmsTemplateQueryResult }>('/sms/templates');
}

export async function createSmsTemplate(data: {
  name: string;
  type: string;
  body: string;
  variables: string[];
  active: boolean;
}) {
  return api.post<{ data: SmsTemplate }>('/sms/templates', data);
}
